import { render } from "./Forgot.vue?vue&type=template&id=61f3c396&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-61f3c396"

export default script